// Sets webpack's runtime publicPath from a WP-injected global. Must run before
// any other module is evaluated (so it is ahead of every other import), because
// lazily-loaded step chunks resolve against publicPath. Import sorting is
// disabled for this file so this side-effect import stays pinned at the top.
/* eslint-disable simple-import-sort/imports */
import "./set-public-path";

import React from "react";
import ReactDOM from "react-dom/client";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { jssPreset, StylesProvider } from "@mui/styles";
import { create } from "jss";

import Providers from "app/providers";
import ErrorBoundary from "components/molecules/error-boundary/ErrorBoundary";

import "./index.css";
import App from "./App";
/* eslint-enable simple-import-sort/imports */

class MyComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: "open" });
    const emotionRoot = document.createElement("style");
    const jssRoot = document.createElement("style");
    emotionRoot.appendChild(jssRoot);
    const mountPoint = document.createElement("div");
    mountPoint.setAttribute("id", "sjd-form-root");
    shadowRoot.appendChild(emotionRoot);
    shadowRoot.appendChild(mountPoint);

    const jss = create({
      ...jssPreset(),
      insertionPoint: jssRoot,
    });

    const cache = createCache({
      key: "css",
      prepend: true,
      container: emotionRoot,
    });

    const root = ReactDOM.createRoot(mountPoint);
    root.render(
      <React.StrictMode>
        {/* Outermost net: catches failures in the providers/theme/store layer
            itself, which the inner boundary in App.tsx sits below and cannot
            see. Without this, such a failure empties the shadow root with no
            remount path (see ErrorBoundary's docblock). */}
        <ErrorBoundary scope="widget">
          <StylesProvider jss={jss}>
            <CacheProvider value={cache}>
              <Providers>
                <App />
              </Providers>
            </CacheProvider>
          </StylesProvider>
        </ErrorBoundary>
      </React.StrictMode>
    );
  }
}

window.addEventListener("load", () => {
  if (!customElements.get("sjd-form")) {
    customElements.define("sjd-form", MyComponent);
  }
});
